import type { QueryClient } from 'react-query'
import type {
  ListScopeFilter,
  ProcessListItem,
  ProcessListResponse,
} from '../types/occurrences'

/** Mesmo valor das chaves `PROCESS_LIST_QUERY_KEY` (hooks/useProcessList). */
const PROCESS_LIST_KEY_PREFIX = ['occurrences', 'process-list'] as const

/** Pedaço da chave de cache para o seletor de empresas — ordenado, para a
 * mesma seleção em outra ordem reaproveitar o cache. */
export function companiesKey(ids?: number[]): string {
  return ids && ids.length > 0 ? [...ids].sort((a, b) => a - b).join(',') : 'all'
}

/** Pedaço da chave de cache para os filtros de escopo (empresas +
 * analistas), ordenados como em `companiesKey`. */
export function scopeKey(scope?: ListScopeFilter): string {
  const names = (list?: string[]) =>
    list?.length ? [...list].sort().join('\u0001') : 'all'
  return [
    companiesKey(scope?.companyIds),
    names(scope?.analysts.client),
    names(scope?.analysts.responsible),
  ].join('|')
}

/** Procura o processo nas páginas da lista "por processo" já em cache. Só as
 * chaves da lista em si: a visão por ocorrência e os contadores ficam sob o
 * mesmo prefixo, mas com outro formato de item. */
export function findProcessInListCache(
  qc: QueryClient,
  processId: number,
): ProcessListItem | undefined {
  const entries = qc.getQueriesData<ProcessListResponse>(PROCESS_LIST_KEY_PREFIX)
  for (const [key, data] of entries) {
    const tag = (key as unknown[])[2]
    if (tag === 'counters' || tag === 'by-occurrence') continue
    const found = data?.items?.find((p) => p.id === processId)
    if (found) return found
  }
  return undefined
}
